import React from 'react';
import type { Text as TextInterface } from '../../design/components';

export const Text: React.FC<TextInterface> = ({
  name, description, state, placeholder, hidden, inline, readonly, disabled, required,
  error, type = 'text', multiline, maxlength, minlength
}) => {
  const [value, setValue] = state || ['', () => {}];

  // Inline mode: render just the text value
  if (inline) {
    return (
      <span style={{ display: hidden ? 'none' : undefined }}>
        {value || ''}
      </span>
    );
  }

  const inputProps = {
    id: name,
    name,
    value: value ?? '',
    placeholder,
    disabled,
    readOnly: readonly,
    required,
    maxLength: maxlength,
    minLength: minlength,
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setValue(e.target.value),
    style: {
      width: '100%',
      padding: '8px 12px',
      fontSize: '16px',
      border: error ? '1px solid red' : '1px solid #ccc',
      borderRadius: '4px',
      boxSizing: 'border-box' as const,
    }
  };

  return (
    <div style={{ marginBottom: '1rem', display: hidden ? 'none' : undefined }}>
      <label htmlFor={name} style={{ display: 'block', marginBottom: '4px', fontWeight: 500 }}>
        {name}
        {required && <span style={{ color: 'red' }}> *</span>}
      </label>
      {multiline && multiline > 1 ? (
        <textarea {...inputProps} rows={multiline} />
      ) : (
        <input {...inputProps} type={type} />
      )}
      {(error || description) && (
        <small style={{ color: error ? 'red' : '#666', display: 'block', marginTop: '4px' }}>
          {error || description}
        </small>
      )}
    </div>
  );
};
